module.exports = (__webpack_require__(0))(89);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/layout/HeaderUserView.js from dll-reference girder_lib
// module id = 139
// module chunks = 0